import(/* webpackMode: "eager" */ "/workspace-install/projects/astrolive-app/modules/Astro/MoreLayout/more-layout.tsx")